// src/components/ui/ConfidenceBar.tsx
import { brand } from '@/lib/tokens';

type Props = {
  /** 0–100 */
  value: number;
  label?: string;
};

function colorFor(value: number): string {
  if (value >= 85) return brand.success;
  if (value >= 60) return brand.accent;
  return brand.error;
}

export function ConfidenceBar({ value, label = 'AI Confidence' }: Props) {
  const clamped = Math.max(0, Math.min(100, value));
  const color = colorFor(clamped);

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-2">
        <span className="mono-label">{label}</span>
        <span
          className="font-mono tabular"
          style={{ color, fontSize: 11.5, letterSpacing: '0.04em' }}
        >
          {clamped}%
        </span>
      </div>
      <div
        style={{
          height: 4,
          width: '100%',
          background: 'rgba(var(--fg-rgb),0.06)',
          borderRadius: 999,
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            height: '100%',
            width: `${clamped}%`,
            background: color,
            transition: 'width 300ms ease',
          }}
        />
      </div>
    </div>
  );
}
